import { withErrorBoundary } from '@sentry/react'
import { Fragment } from 'react'

import Company1 from 'src/assets/company/1.png'
import Company2 from 'src/assets/company/2.png'
import Company3 from 'src/assets/company/3.png'
import Company4 from 'src/assets/company/4.png'
import Company5 from 'src/assets/company/5.png'
import Company6 from 'src/assets/company/6.png'
import ORNALogo from 'src/assets/orna_transparent_text_white_logo.png'
import PlayBtn from 'src/assets/play_btn.png'

import SentryFallback from './SentryFallback'

const CommonBanner = () => {
    return (
        <Fragment>
            <div>
                <img
                    alt="orna-text-logo"
                    src={ORNALogo}
                    className="h-10 w-auto"
                />
            </div>
            <div className="mt-10">
                <div className="mt-0 font-Roboto">
                    <div className="text-3xl font-light text-primary-red">
                        Security orchestration for DFIR teams
                    </div>
                    <div className="mt-3 text-49-57 font-bold text-white">
                        Best-in-Class
                        <br /> Incident Response
                        <br /> and Case Management
                    </div>
                </div>
                {/* TODO check order for brand images */}
                <div className="flex gap-10">
                    <img
                        className="h-24 w-24"
                        alt="orna-text-logo"
                        src={Company1}
                        // className="w-auto h-10"
                    />
                    <img
                        className="h-24 w-24"
                        alt="orna-text-logo"
                        src={Company2}
                        // className="w-auto h-10"
                    />
                    <img
                        className="h-24 w-24"
                        alt="orna-text-logo"
                        src={Company3}
                        // className="w-auto h-10"
                    />
                    <img
                        className="h-24 w-24"
                        alt="orna-text-logo"
                        src={Company4}
                        // className="w-auto h-10"
                    />
                    <img
                        className="h-24 w-24"
                        alt="orna-text-logo"
                        src={Company5}
                        // className="w-auto h-10"
                    />
                    <img
                        className="h-24 w-24"
                        alt="orna-text-logo"
                        src={Company6}
                        // className="w-auto h-10"
                    />
                </div>
            </div>
            <div className="mt-10 pt-2 font-Roboto">
                <div className="flex cursor-pointer items-center">
                    <a
                        href="https://www.youtube.com/watch?v=Z7x2iSuAKFI"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={PlayBtn} alt="play video" />
                    </a>
                    <div className="pl-5 font-Roboto text-12-14 text-white hover:text-gray-200">
                        Watch Narrated ORNA Tour
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default withErrorBoundary(CommonBanner, {
    fallback: <SentryFallback />,
})
